import { useEffect, useState } from "react";

/**
 * Live D:H:M:S countdown to a given ISO date/time.
 * Shows an inline "Available now" line the moment the target passes.
 */
export default function WithdrawalCountdown({ targetIso, label = "Next withdrawal in" }) {
  const [now, setNow] = useState(() => Date.now());

  useEffect(() => {
    const id = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(id);
  }, []);

  if (!targetIso) return null;
  const target = new Date(targetIso).getTime();
  const remain = target - now;

  if (!Number.isFinite(remain) || remain <= 0) {
    return (
      <p className="mt-2 text-[11px] uppercase tracking-[0.2em] text-[#00FF41]" data-testid="wd-countdown-ready">
        Available now — refresh the page
      </p>
    );
  }

  const days = Math.floor(remain / 86_400_000);
  const hours = Math.floor((remain % 86_400_000) / 3_600_000);
  const mins = Math.floor((remain % 3_600_000) / 60_000);
  const secs = Math.floor((remain % 60_000) / 1000);

  const cell = "flex-1 border border-gold/25 bg-ink/60 px-2 py-2 text-center";

  return (
    <div className="mt-3" data-testid="wd-countdown">
      <p className="text-[9px] uppercase tracking-[0.28em] text-white/45">{label}</p>
      <div className="mt-2 flex gap-1.5">
        <div className={cell}>
          <p className="font-tabular text-lg text-gold" data-testid="wd-countdown-days">{String(days).padStart(2, "0")}</p>
          <p className="text-[8px] uppercase tracking-[0.2em] text-white/40">Days</p>
        </div>
        <div className={cell}>
          <p className="font-tabular text-lg text-gold" data-testid="wd-countdown-hours">{String(hours).padStart(2, "0")}</p>
          <p className="text-[8px] uppercase tracking-[0.2em] text-white/40">Hours</p>
        </div>
        <div className={cell}>
          <p className="font-tabular text-lg text-gold" data-testid="wd-countdown-mins">{String(mins).padStart(2, "0")}</p>
          <p className="text-[8px] uppercase tracking-[0.2em] text-white/40">Mins</p>
        </div>
        <div className={cell}>
          <p className="font-tabular text-lg text-gold" data-testid="wd-countdown-secs">{String(secs).padStart(2, "0")}</p>
          <p className="text-[8px] uppercase tracking-[0.2em] text-white/40">Secs</p>
        </div>
      </div>
      <p className="mt-2 text-[10px] uppercase tracking-[0.2em] text-white/40" data-testid="wd-countdown-target">
        On {new Date(targetIso).toLocaleString(undefined, { dateStyle: "medium", timeStyle: "short" })}
      </p>
    </div>
  );
}
